import { validateApiResponseWithZod } from '@nw/shared/utils';

import { UserProfileDetailsSchema } from '../../../types/Schemas.zod';
import { UserProfileDetailsType } from '../../../types/zodSchemaTypes';

import { UserProfileDetailsDTO } from '../../dtos/userProfileDetail.dtos';

export const getUserProfileDetailsTransformer = (
  data: UserProfileDetailsType
): UserProfileDetailsDTO => {
  const validateResponse = validateApiResponseWithZod(
    data,
    UserProfileDetailsSchema
  ) as UserProfileDetailsType;
  const {
    user_id,
    email,
    permanent_address_details,
    phone_number,
    country_code,
    profile_pic_url,
    name,
    dob,
    gender,
    is_phone_number_verified,
    is_email_verified,
    cover_page_url,
    age,
    state_of_residence,
    occupation,
    last_name,
    current_city,
    current_state,
    current_country,
    current_district,
    invite_code,
    pincode,
    whatsapp_mobile_number,
    whatsapp_mobile_number_country_code,
    i_want_to_receive_updates_directly_on_whatsapp,
    can_update_phone_number,
    can_update_phone_number_after_datetime,
    preferred_languages,
    nationality,
    family_income
  } = validateResponse;
  return {
    userID: user_id,
    email: email ? email : '',
    permanentAddressDetails: {
      doorNoAndStreet: permanent_address_details?.door_no_and_street,
      city: permanent_address_details?.city,
      district: permanent_address_details?.district,
      state: permanent_address_details?.state,
      country: permanent_address_details?.country,
      pincode: permanent_address_details?.pincode
    },
    phoneNumber: phone_number ? phone_number : '',
    countryCode: country_code ? country_code : '',
    profilePicUrl: profile_pic_url ? profile_pic_url : '',
    name: name ? name : '',
    dob: dob ? dob : '',
    gender: gender ? gender : '',
    isPhoneNumberVerified: is_phone_number_verified
      ? is_phone_number_verified
      : false,
    isEmailVerified: is_email_verified ? is_email_verified : false,
    coverPageUrl: cover_page_url ? cover_page_url : '',
    age: age ? age : 0,
    stateOfResidence: state_of_residence ? state_of_residence : '',
    occupation: occupation ? occupation : '',
    lastName: last_name ? last_name : '',
    currentCity: current_city ? current_city : '',
    currentState: current_state ? current_state : '',
    currentCountry: current_country ? current_country : '',
    currentDistrict: current_district ? current_district : '',
    pinCode: pincode ? pincode : '',
    inviteCode: invite_code ? invite_code : '',
    whatsappMobileNumber: whatsapp_mobile_number ? whatsapp_mobile_number : '',
    whatsappMobileNumberCountryCode: whatsapp_mobile_number_country_code
      ? whatsapp_mobile_number_country_code
      : '',
    iWantToReceiveUpdatesDirectlyOnWhatsapp:
      i_want_to_receive_updates_directly_on_whatsapp
        ? i_want_to_receive_updates_directly_on_whatsapp
        : false,
    canUpdatePhoneNumber: can_update_phone_number
      ? can_update_phone_number
      : false,
    phoneNumberUpdateDueDateTime: can_update_phone_number_after_datetime
      ? can_update_phone_number_after_datetime
      : '',
    preferredLanguages: preferred_languages ? preferred_languages : [],
    nationality: nationality ? nationality : '',
    familyIncome: family_income ? family_income : ''
  };
};
